import { getUnixTime, isValid, parseISO } from 'date-fns'

export const SORT_PROGRESS = 'progress'
export const SORT_NAME = 'name'
export const SORT_DATE = 'date'
export const SORT_SUBJECT = 'subject'

export const ORDER_ASC = 'asc'
export const ORDER_DESC = 'desc'

export const sortByStatus = (scholarships, order) => {
  return scholarships.sort((a, b) => {
    const statusA = parseInt(a.application.status, 10)
    const statusB = parseInt(b.application.status, 10)
    return order ? (statusB - statusA) : (statusA - statusB)
  })
}

const dateStringToUnix = (dateString: string): number => {
  const date = parseISO(dateString)
  if (!isValid(date)) { return 0 }
  return getUnixTime(date)
}

export const sortByDate = (mails, order) => {
  if (mails === null || mails === undefined) { return }
  mails.sort((a, b) => dateStringToUnix(a.date) - dateStringToUnix(b.date))

  return order ? mails.reverse() : mails
}

export const sortByPropertyName = (mails, propName, asc) => {
  if (!Array.isArray(mails) || !propName || !mails[0][propName]) { throw new Error('Please provide correct parameters') }

  mails.sort((a, b) => {
    const valueA = a[propName].toUpperCase()
    const valueB = b[propName].toUpperCase()

    if (valueA > valueB) { return 1 }
    if (valueB < valueA) { return -1 }
    return 0
  })

  return asc ? mails.reverse() : mails
}

export function applySorting(source, sortBy, order) {
  order = order === ORDER_ASC

  if (sortBy === SORT_DATE) {
    return sortByDate(source, order)
  }

  if (sortBy === SORT_SUBJECT) {
    return sortByPropertyName(source, 'subject', !order)
  }

  if (sortBy === SORT_NAME) {
    const targetField = source.folder === 'Inbox' ? 'sender' : 'recipient'
    return sortByPropertyName(source, targetField, order)
  }

  if (sortBy === SORT_PROGRESS) {
    return sortByStatus(source, order)
  }

  throw new Error('Provided wrong sorting sign!')
}
